<template functional>
  <svg
    style="height: .5em; width: .5em; fill:currentColor"
    :class="{
      [data.staticClass || ``]: true,
      'u-flip-left': props.direction === 'left',
    }"
    viewBox="0 0 16 16"
    width="32"
    height="32"
  >
    <title><slot/></title>
    <path d="M4 16l8-8-8-8 4 8z"></path>
  </svg>
</template>

<script>
export default {
  props: {
    direction: {
      type: String,
      validator: value => [`left`, `right`].indexOf(value) !== -1,
      default: `right`,
    },
  },
}
</script>

<style>
.u-flip-left {
  transform: scaleX(-1);
}
</style>
